import { AfterViewInit, Component, ElementRef, Inject, Injector, OnDestroy, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

import { Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';

// Services
import { WebcomponentsService } from '@core/service/webcomponents.service';

// Enums
import { ProductType } from '@core/model/enums';

@Component({
  selector: 'app-simulation-modal',
  templateUrl: './simulation-modal.component.html',
  styleUrls: ['./simulation-modal.component.css'],
})
export class SimulationModalComponent implements AfterViewInit, OnDestroy {
  @ViewChild('loanCostsWidgetRef') public loanCostsWidgetRef: ElementRef;

  private readonly webcomponentsService: WebcomponentsService;
  private readonly unsubscribe$: Subject<void>;

  constructor(
    private readonly injector: Injector,
    @Inject(MAT_DIALOG_DATA) private loanCostsData: { amount: number; term: number }
  ) {
    this.webcomponentsService = this.injector.get(WebcomponentsService);
    this.unsubscribe$ = new Subject();
  }

  public ngAfterViewInit(): void {
    this.webcomponentsService.isLoaded$.pipe(filter(Boolean), takeUntil(this.unsubscribe$)).subscribe({
      next: () => {
        const widget = this.loanCostsWidgetRef.nativeElement;
        widget.ngElementStrategy.componentRef.instance.build({
          amount: this.loanCostsData.amount,
          term: this.loanCostsData.term,
          productCode: ProductType.RP,
          isConsolidated: true,
          alliance: this.alliance,
        });
      },
    });
  }

  public ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
    this.destroyWidget();
  }

  private destroyWidget(): void {
    const widget = this.loanCostsWidgetRef.nativeElement;
    widget.ngElementStrategy.componentRef.instance.destroyInstance();
  }

  private get alliance(): string | undefined {
    return sessionStorage.getItem('ac') ?? undefined;
  }
}
